import React from 'react';

const ControlPanel = ({ children }) => {
    return (
        <div className="control-panel">
            {children}
        </div>
    );
};

export default ControlPanel;
